const { exec } = require("child_process");

const executeUnixCommand = (command) =>
  new Promise((resolve, reject) => {
    exec(
      command,
      {
        maxBuffer:
          Number(process.env.EXEC_MAX_BUFFER) ||
          850000000 /* 850 megabytes in bytes */,
      },
      (error, stdout) => {
        if (error) {
          console.log(error);
          reject(error);
        }
        console.log(stdout);
        resolve(stdout);
      }
    );
  });

module.exports = {
  executeUnixCommand,
};
